import styled from 'styled-components/macro';
import { Separator } from '@yme/atoms/separator';
export const SeparatorStyled = styled(Separator) `
  text-transform: uppercase;
`;
export const PayeverContainerStyled = styled.div `
  & .pe-widget-card {
    margin: 0;
    padding: 0;
    background: none;
  }
`;
